import { useParams } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useNotification } from 'src/hooks/useNotification';
import { useLoader } from 'src/provider/LoaderProvider';
import { useAppSelector } from 'src/store';
import { useUpdateIntegrationMutation } from 'src/services';
import { IncludeSubjectField } from 'src/components/Integrations/IntegrationForms/IntegrationFormFields/IncludeSubjectField/IncludeSubjectField';
import { AIAssistantModeFiled } from 'src/components/Integrations/IntegrationForms/IntegrationFormFields/AIAssistantModeField/AIAssistantModeFiled';
import { Separator } from 'src/components/ui/separator';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { object } from 'yup';
import { booleanScheme } from 'src/utils/validation-schemes';
import { setSelectedIntegration } from 'src/store/slices/integrationSlice';
import { useDispatch } from 'react-redux';

export const ZendeskEmailStep5 = ({
  onClose = (_v?: any) => {},
  onClick = (_v?: any) => {},
}: {
  onClose?: (v?: any) => void;
  onClick?: (v?: any) => void;
}) => {
  const { id } = useParams();
  const notification = useNotification();
  const loader = useLoader();
  const { selectedIntegration } = useAppSelector((s) => s.integrationSlices);
  const [
    updateIntegration,
    {
      data: updatedIntegrationData,
      isLoading: isLoadingUpdateIntegration,
      isSuccess: isSuccessUpdateIntegration,
    },
  ] = useUpdateIntegrationMutation() as any;
  const dispatch = useDispatch();

  const { handleSubmit, control } = useForm({
    defaultValues: {
      reply_to_note: selectedIntegration?.integration_data?.reply_to_note || false,
      include_subject_first_response:
        selectedIntegration?.integration_data?.include_subject_first_response || false,
    },
    resolver: yupResolver(
      object({
        reply_to_note: booleanScheme().label('AI assistant mode'),
        include_subject_first_response: booleanScheme().label(
          'Include the email subject line in the context',
        ),
      }),
    ),
  });

  useEffect(() => {
    if (isSuccessUpdateIntegration) {
      notification.success('Integration Updated.');
      onClose(true);
    }
  }, [isSuccessUpdateIntegration]);

  useEffect(() => {
    if (isLoadingUpdateIntegration) {
      loader.show();
    } else {
      loader.hide();
    }
  }, [isLoadingUpdateIntegration]);

  useEffect(() => {
    if (updatedIntegrationData) {
      dispatch(setSelectedIntegration({ ...selectedIntegration, ...updatedIntegrationData }));
    }
  }, [updatedIntegrationData]);

  const submit = async (data) => {
    const request = {
      status: selectedIntegration.status,
      integration_type: selectedIntegration.integration_type,
      integration_data: {
        ...selectedIntegration.integration_data,
        reply_to_note: data.reply_to_note,
        include_subject_first_response: data.include_subject_first_response,
      },
    };

    updateIntegration({
      projectId: id,
      integrationId: selectedIntegration.id,
      body: request,
    });
  };

  return (
    <form id={'zendesk-email-step5-form'} onSubmit={handleSubmit(submit)}>
      <IncludeSubjectField control={control} />
      <Separator className={'bg-[#E3E6E8] my-5'} />
      <AIAssistantModeFiled control={control} />
    </form>
  );
};
